export default __webpack_public_path__ + "static/media/resnetgru5.44b320fd.png";